import React from "react";
import { useLocation } from "react-router-dom";

export default function WhatsAppFloat() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/call/")) return null;
  return (
    <a
      data-testid="whatsapp-float"
      href="https://wa.me/917980481612"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-[9999] flex items-center gap-2 bg-[#25D366] text-white rounded-full px-4 py-3 shadow-2xl hover:scale-105 transition-transform pulse-ring"
    >
      <svg viewBox="0 0 32 32" className="w-6 h-6 fill-white"><path d="M19.11 17.43c-.27-.13-1.58-.78-1.82-.87-.24-.09-.42-.13-.6.13-.18.27-.69.87-.84 1.05-.15.18-.31.2-.58.07-.27-.13-1.13-.42-2.16-1.32-.8-.71-1.34-1.59-1.49-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.31.4-.46.13-.15.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.6-1.45-.82-1.99-.22-.52-.44-.45-.6-.46h-.51c-.18 0-.47.07-.71.34-.24.27-.93.91-.93 2.22 0 1.31.96 2.58 1.09 2.76.13.18 1.89 2.88 4.59 4.04.64.28 1.14.45 1.53.58.64.2 1.23.17 1.69.1.51-.08 1.58-.65 1.81-1.28.22-.63.22-1.17.16-1.28-.07-.12-.25-.18-.51-.31zM16 4C9.38 4 4 9.38 4 16c0 2.27.63 4.49 1.82 6.4L4 28l5.78-1.78A11.95 11.95 0 0 0 16 28c6.62 0 12-5.38 12-12S22.62 4 16 4z"/></svg>
      <span className="hidden sm:inline text-sm font-semibold">Chat with us</span>
    </a>
  );
}
